import {defineMessages} from 'react-intl.macro';

export const messages = defineMessages({
  'dashboard.buttons.noAction': {
    defaultMessage: 'No Action Required',
    id: 'dashboard.buttons.noAction'
  },
  'dashboard.buttons.resolve': {
    defaultMessage: 'Resolve',
    id: 'dashboard.buttons.resolve'
  },
  'dashboard.checkPoints': {
    defaultMessage: 'Checkpoints',
    id: 'dashboard.checkPoints'
  },
  'dashboard.checkpoint.title': {
    defaultMessage: 'Checkpoint',
    id: 'dashboard.checkpoint.title'
  },
  'dashboard.checkpointType.title': {
    defaultMessage: 'Checkpoint Type',
    id: 'dashboard.checkpointType.title'
  },
  'dashboard.errorService': {
    defaultMessage: 'Service unavailable, please try again later.',
    id: 'dashboard.errorService'
  },
  'dashboard.itemsCaption': {
    defaultMessage: 'This section identifies any possible problems with your configuration.',
    id: 'dashboard.itemsCaption'
  },
  'dashboard.libraries.title': {
    defaultMessage: 'Libraries',
    id: 'dashboard.libraries.title'
  },
  'dashboard.libraryManagement': {
    defaultMessage: 'Library Management',
    id: 'dashboard.libraryManagement'
  },
  'dashboard.name': {
    defaultMessage: 'Dashboard',
    id: 'dashboard.name'
  },
  'dashboard.noItemsCaption': {
    defaultMessage: 'There are no known issues with your configuration.',
    id: 'dashboard.noItemsCaption'
  },
  'dashboard.unassignedcheckpoints.body': {
    defaultMessage: 'Checkpoints with no location set.',
    id: 'dashboard.unassignedcheckpoints.body'
  },
  'dashboard.unassignedcheckpoints.header': {
    defaultMessage: 'Unassigned Checkpoints',
    id: 'dashboard.unassignedcheckpoints.header'
  },
  'dashboard.userDefinedRoles': {
    defaultMessage: 'User-Defined Roles',
    id: 'dashboard.userDefinedRoles'
  },
  'dashboard.userRoles': {
    defaultMessage: 'User Roles',
    id: 'dashboard.userRoles'
  }
});
